<template>
    <div>
        <p>
            {{ introText }}
        </p>

        <p class="mt-sm">
            {{ userSettingText }} <u>user</u>
        </p>

        <validation-errors :error="error" />

        <form ref="form">
            <text-input
                v-model="password"
                :label="lang('Lösenord','Password')"
                type="password"
                name="password"
                :required="true"
                :autofocus="true"
            />

            <text-input
                v-model="confirmPassword"
                :label="lang('Upprepa lösenord','Repeat password')"
                type="password"
                name="confirm_password"
                :required="true"
                :autofocus="true"
            />
        </form>

        <div class="bg-neutral-lighter py-lg my-lg px-xl -mx-2xl -mb-2xl">
            <div class="button-group">
                <button
                    type="button"
                    class="btn is-ghost btn-lg"
                    @click="$emit('back')"
                >
                    {{ lang('Tillbaka','Back') }}
                </button>

                <button
                    type="button"
                    class="btn is-ghost-link btn-lg"
                    @click="$emit('next')"
                >
                    {{ lang('Hoppa över','Skip') }}
                </button>

                <button
                    type="button"
                    class="btn btn-lg is-primary ml-auto"
                    @click="save"
                >
                    {{ lang('Spara lösenord','Save password') }}
                </button>
            </div>
        </div>
    </div>
</template>
<script>
    import ValidationErrors from '../ValidationErrors';

    export default {
        components: {
            ValidationErrors,
        },
        data() {
            return {
                password: null,
                confirmPassword: null,
                error: {},
                introText: lang(
                    'Här väljer du ett personligt lösenord som används för att logga in på routern genom webbläsaren. Du kan logga in på din router för att göra mer avancerade inställningar utöver de inställningar du gör här.',
                    'This is where you choose a password that will be used to sign in to the router through a webbrowser. You sign in to the router when you wish to configure more advanced settings.'
                ),
                userSettingText: lang(
                    'Det förinställda användarnamnet är:', 'The default username is:'
                ),
            };
        },
        mounted() {
            this.$emit(
                'title',
                lang('Välj lösenord för routern', 'Choose a router password')
            );
        },
        methods: {
            async save() {
                this.loading = true;
                this.error = {};

                try {
                    const response = await axios.patch(route('front.my-pages.api.router.update-password'), {
                        password: this.password,
                        password_confirmation: this.confirmPassword,
                    });

                    if (response.data.error) {
                        this.error.push(response.data.error);
                        return;
                    }

                    this.$emit('next');
                } catch (error) {
                    if (error.response.status === 401) {
                        this.error = {
                            message: lang(
                                'Din session har löpt ut, vänligen ladda om sidan och logga in igen.',
                                'Session expired, please reload the page and log in again.'
                            ),
                        };

                        return;
                    }

                    if (error.response.data.hasOwnProperty('errors')) {
                        this.error = error.response.data;
                        return;
                    }

                    this.error = {
                        message: lang(
                            'Vi kunde inte uppdatera din router. Var god kontakta kundtjänst om problemet kvarstår.',
                            'We could not update your router. Please contact customer support if the problem persists.',
                        ),
                    };
                }

                this.loading = false;
            },
        },
    };
</script>